/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GeoFormData,
    GeoFormDataFromJSON,
    GeoFormDataFromJSONTyped,
    GeoFormDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormDataRouteRestriction
 */
export interface FormDataRouteRestriction {
    /**
     * 
     * @type {GeoFormData}
     * @memberof FormDataRouteRestriction
     */
    from?: GeoFormData;
    /**
     * 
     * @type {GeoFormData}
     * @memberof FormDataRouteRestriction
     */
    to?: GeoFormData;
    /**
     * 
     * @type {boolean}
     * @memberof FormDataRouteRestriction
     */
    match?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormDataRouteRestriction
     */
    isOutbound?: boolean;
}

export function FormDataRouteRestrictionFromJSON(json: any): FormDataRouteRestriction {
    return FormDataRouteRestrictionFromJSONTyped(json, false);
}

export function FormDataRouteRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormDataRouteRestriction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : GeoFormDataFromJSON(json['from']),
        'to': !exists(json, 'to') ? undefined : GeoFormDataFromJSON(json['to']),
        'match': !exists(json, 'match') ? undefined : json['match'],
        'isOutbound': !exists(json, 'isOutbound') ? undefined : json['isOutbound'],
    };
}

export function FormDataRouteRestrictionToJSON(value?: FormDataRouteRestriction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': GeoFormDataToJSON(value.from),
        'to': GeoFormDataToJSON(value.to),
        'match': value.match,
        'isOutbound': value.isOutbound,
    };
}


